import React, { useEffect, useState } from "react";
import BackButton from "../bars/BackButton";
import CheckImg from "../../images/check.svg";
import GreenCheck from "../../images/greenCheck.svg";
import RoomDataModal from "../../components/RoomDataModal";
import axios from "axios";
import { baseURL } from "../../constants/Api";
import BottonToggle from "../bars/BottomToggle";
function HotelData() {
  const [showRoomModal, setShowRoomModal] = useState(false);
  const [hoteldata, setHotelData] = useState([]);
  const [roomData, setRoomData] = useState([]);
  const urlArray = window.location.href.split("/");
  const lastWord = urlArray[urlArray.length - 1];
  const dashIndex = lastWord.lastIndexOf("-");
  const slug = lastWord.substring(0, dashIndex);
  const hotelId = lastWord.substring(dashIndex + 1);
  const ffd = ["Twin bed"];
  const fetchHotelData = async () => {
    try {
      await axios({
        method: "get",
        url: `${baseURL}/api/listHotels/${hotelId}/${slug}`,
        headers: { "Content-Type": "application/json" },
      }).then(function (response) {
        setHotelData(response.data.data);
        console.log(response.data.data);
      });
    } catch {
      console.log();
    }
  };

  const showData = (param) => {
    var data = {
      img: param.roomImages.length !== 0 ? param.roomImages[0] : "gray",
      name: param.roomName,
      description: param.description,
      fecilities: param.fecilities,
    };
    setRoomData(data);
  };

  useEffect(() => {
    fetchHotelData();
  }, []);
  return (
    <div className="hotel-inner-page  pb-32">
      <div className="w-full section-wrap relative">
         <div className="absolute sm:left-[35px] top-3">
          <BackButton whiteTheme/>
        </div>
      </div>

      <div
        className="hotel-img-bg bg-cover bg-no-repeat"
        style={{
          background:
            hoteldata.length !== 0
              ? hoteldata.images.length !== 0
                ? `url(${hoteldata.images[0]})`
                : "gray"
              : "",
        }}
      ></div>
      {hoteldata && (
        <div>
          <div className="mt-4 section-wrap relative">
            <div className="name">{hoteldata.name}</div>
            <div className="place">
              {hoteldata.address}, {hoteldata.city}
            </div>
            <div className="sub-head mb-1 mt-3">Description</div>
            <p>{hoteldata.description}</p>
            {hoteldata.roomFeatures && hoteldata.roomFeatures.length !== 0 && (
              <div>
                <div className="room-head mt-5">Room types</div>
                <div className="grid grid-flow-row lg:grid-cols-5 grid-cols-2 gap-5 mt-3">
                  {hoteldata.roomFeatures.map((item, i) => (
                    <div
                      className="room-card"
                      onClick={() => showData(item)}
                      hide={() => setShowRoomModal(false)}
                    >
                      <div
                        className="hotel-img h-[90px] w-full"
                        style={{
                          background:
                            item.roomImages.length !== 0
                              ? `url(${item.roomImages[0]})`
                              : "gray",
                          backgroundSize: "cover",
                        }}
                      ></div>
                      <div className="name mt-2 mb-2">{item.roomName}</div>
                      {item.fecilities.length >= 1 && (
                        <div className="flex gap-2 mb-1 items-center">
                          <div className="w-3 h-3 ">
                            <img src={CheckImg} alt="" />
                          </div>
                          <div className="type-name">{item.fecilities[0]}</div>
                        </div>
                      )}
                      {item.fecilities.length >= 2 && (
                        <div className="flex gap-2 mb-1 items-center">
                          <div className="w-3 h-3 ">
                            <img src={CheckImg} alt="" />
                          </div>
                          <div className="type-name">{item.fecilities[1]}</div>
                        </div>
                      )}

                      <div className="see-more text-right">See more...</div>
                    </div>
                  ))}
                </div>
              </div>
            )}
            {hoteldata.hotelGuides && hoteldata.hotelGuides.length != 0 && (
              <div className="facilities mt-5">
                <div className="sub-head mb-4">Facilities </div>
                <div className="grid grid-flow-row xl:grid-cols-5 lg:grid-cols-4 sm:grid-cols-3  grid-cols-2  gap-5 lg:mt-6 mt-3">
                  {hoteldata.hotelGuides.map((item, i) => (
                    <div className="flex items-center mb-3 gap-2">
                      <img className="w-4 h-4" src={GreenCheck} />
                      <div className="facility">{item.name}</div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
          <div className="fixed left-1/2 -translate-x-1/2 bottom-6 w-full">
            <a href={`tel:${hoteldata.phone}`} className="contact-btn block">
              Contact
            </a>
          </div>
        </div>
      )}

      {roomData.length !== 0 && (
        <RoomDataModal roomData={roomData} hide={() => setRoomData([])} />
      )}
    </div>
  );
}

export default HotelData;
